import { useState } from "react";
import { ICompanyFormData } from "../../models/ICompany";
import { useFieldErrors, IFieldErrors } from "@common/hooks/useFieldErrors";
import { useTranslation } from "react-i18next";

export type IUseCompanyFormHook = (initialData?: ICompanyFormData) => {
    formData: ICompanyFormData;
    update: (values: Partial<ICompanyFormData>) => void;
    validate: (values: ICompanyFormData) => IFieldErrors<ICompanyFormData> | null;
    errors: IFieldErrors<ICompanyFormData>;
    hasErrors: boolean;
};

export const useCompanyForm: IUseCompanyFormHook = (initialData = {}) => {
    const t = useTranslation().t;

    const [formData, setFormData] = useState<ICompanyFormData>(initialData);
    const [fieldErrors, setErrors] = useFieldErrors<ICompanyFormData>()

    const update = (values: ICompanyFormData) => {
        setFormData((prevData) => ({ ...prevData, ...values }))
    };

    const validate = (values: ICompanyFormData) => {
        let errors: typeof fieldErrors = {};
        if (!values.name) {
            errors.name = t("Pakollinen");
        };
        setErrors(errors);
        return Object.keys(fieldErrors).length ? errors : null;
    };

    return {
        formData,
        update,

        validate,
        errors: fieldErrors,
        hasErrors: Boolean(Object.keys(fieldErrors).length)
    }


};